import { mdiArrowULeftTop, mdiCardMultipleOutline, mdiInformationOutline } from "@mdi/js"
import LineString from "ol/geom/LineString"
import Point from "ol/geom/Point"
import { Interaction, Select } from "ol/interaction"
import VectorSource from "ol/source/Vector"
import Vue from "vue"
import CloudGpxInfo from "./CloudGpxInfo"
import CloudNameChecker from "./CloudNameChecker"
import DistanceUnits from "./DistanceUnits"
import { docPages } from "./DocPages"
import GpxFileNameChecker from "./GpxFileNameChecker"
import Product from "./Product"
import PublicShareInfo from "./PublicShareInfo"
import { Renderer } from "./Renderer"
import { RendererMetadata } from "./RendererMetadata"
import { StartRenderer } from "./StartRenderer"
import { TrackEntity } from "./TrackEntity"
import TrackPointLimitChecker from "./TrackPointLimitChecker"
import Undoable from "./Undoable"
import { WaypointsEntity } from "./WaypointEntity"
import WaypointFeature from "./WaypointFeature"
import Chart, { ChartEvent } from "chart.js"
import ElevationChartHoverIndicator from "./ElevationChartHoverIndicator"
import SingleFeatureSource from "./SingleFeatureSource"
import WaypointLayer from "./WaypointLayer"
import VectorLayer from "ol/layer/Vector"
import CustomVectorLayer from "./CustomVectorLayer"
import Feature from "ol/Feature"
import AppState from "./AppState"
import SubscriptionValidResult from "./SubscriptionValidResult"

export const AllTracksInOneGpx = 'AllTracksInOneGpx'
export const CurrentTrack = 'CurrentTrack'
export const DefaultDownloadOption = AllTracksInOneGpx

export default class HomeData extends Vue {
    reverseTrackIcon = mdiArrowULeftTop
    cardMultipleIcon = mdiCardMultipleOutline
    informationOutlineIcon = mdiInformationOutline
    sidebar = false
    dialog = ''
    nextRouteId = 0
    renderers = [] as RendererMetadata<any>[]
    validRenderers = [] as RendererMetadata<any>[]
    renderer = "osm"
    currentRenderer = new StartRenderer("none") as Renderer<any>
    tracks = [] as TrackEntity[]
    waypoints = new WaypointsEntity()
    currentTrack = ''
    select = null as Select | null
    operations = [
        { name: 'move', icon: 'mdi-hand-right', tooltip: 'Pan mode' },
        { name: 'draw', icon: 'mdi-draw', tooltip: 'Drawing mode' },
        { name: 'drag', icon: 'mdi-map-marker-path', tooltip: 'Re-routing mode' },
        { name: 'waypoint', icon: 'mdi-map-marker', tooltip: 'Add waypoint mode' },
        { name: 'split', icon: '', tooltip: 'Split track mode' },
    ]
    currentOperations = [] as Interaction[]
    initialLoginOperation = 0
    initialLoginWantsToUpgrade = false
    operation = 1
    snackbar = false
    snackbarColor = ''
    snackbarText = ''
    fullAccessProduct = null as Product|null
    priceIdUpgrading = null as string|null
    managingSubscription = false
    renamingTrack = false
    routingLineFeatureSource = new VectorSource<LineString>({features: []})
    joinIndicatorFeatureSource = new VectorSource<Point>({})
    trackToDelete = null as string|null
    showSaveToFileDialog = false
    gpxFileNameChecker = new GpxFileNameChecker()
    trackPointLimitChecker = new TrackPointLimitChecker()
    showWaypointIconPicker = false
    showWaypointColourPicker = false
    showWaypointProximityAlarmPicker = false
    showCurrentTrackColourPicker = false
    distanceUnit = 'mi'
    distanceUnits = DistanceUnits
    showSubscriberOnlyDialog = false
    subscriberOnlyDialogText = null as string|null
    subscriberOnlyExtraMessage = null as string|null
    subscriberOnlyDrawInNewWorkspace = 'drawinnewworkspace'
    locating = false
    cloudNameChecker = new CloudNameChecker()
    fileToUpload = null as File|null
    cloudsidebar = false
    cloudsidebartab = null as number|null
    cloudDeleteParams = null as CloudGpxInfo|null
    cloudDeleting = false
    selectedWaypoint: WaypointFeature|null = null
    editingWaypointName = false
    trackPointLimit = null as number|null // initial null forces vue to set it initially, thus call onCloudGpxsInvalidated, when it sets the model of the tabs to 0.
    permanentInteractions = [] as Interaction[]
    showPlaceSearch = false
    placeSearchAutoComplete = null as google.maps.places.Autocomplete|null
    undoCommands = [] as Undoable[]
    capturedData = 'abc'
    capturedNumber = 1
    saveFileName = 'Untitled.gpx'
    navigationDrawerIsMobile = true
    sidebarStateBeforeCloudSidebarWasShown = null as boolean|null
    helpPages = docPages
    settingTrackZIndexes = false
    loadedTrackGpxUrl = null as string|null
    loadedTrackOwnedByCurrentUser = null as boolean|null
    loadedTrackIsPublic = null as boolean|null
    publicShareInfo = {
        downloadUrl: '',
        name: '',
        url: ''
    } as PublicShareInfo
    showShareToCloudDialog = false
    showPublicShareDialog = false
    showLoadFileDialog = false
    progressMessage = null as string|null
    showingDistanceForCurrentTrack = false
    showingDistanceForAllTracks = false
    elevationChart = null as Chart.Chart|null
    gettingElevationData = false
    elevationChartHoverIndicator = null as ElevationChartHoverIndicator|null
    elevationChartIndicatorFeatureSource = new SingleFeatureSource<Point>()
    elevationChartLastHoverEvent = null as ChartEvent|null
    elevationChartPaneSize = 20
    elevationChartClimbingSuffix = ''
    elevationChartNeedsToRepaintBackground = true
    trackpointEditing = false
    gpxAsString = ''
    proximityAlarmOptions = [
        {text: 'None', value: null},
        {text: '10m', value: 10},
        {text: '20m', value: 20},
        {text: '50m', value: 50},
        {text: '100m', value: 100},
        {text: '500m', value: 500},
        {text: '1km', value: 1000}
    ]
    waypointLayer: WaypointLayer|null = null
    auxiliaryMarkersLayer: CustomVectorLayer<VectorSource<Point>>|null = null
    auxiliaryMarkersFeatureSource = new VectorSource<Point>()
    currentLocationMarker: Feature<Point>|null = null
    elevationChartHoverIndicatorLayer: VectorLayer<VectorSource<Point>>|null = null
    downloadOption = DefaultDownloadOption
    cloudGpxSortDirection = 0
    cloudGpxFilter = ''
    cloudGpxs: CloudGpxInfo[] = []
    showHoverDistance = false
    appState = new AppState()
    mergeSegmentsOnSaveToFile = true
    
    showSubscriptionInvalid = false
    subscriptionValidResult: SubscriptionValidResult|null = null
    showRemoveSubscriberInfo = false

}